import { render } from "./Poblaciones.vue?vue&type=template&id=52250861"
import script from "./Poblaciones.vue?vue&type=script&lang=ts"
export * from "./Poblaciones.vue?vue&type=script&lang=ts"
script.render = render

export default script